omadapp.components.Question = function ($context,data) {
	var t = this
	var $ = jQuery

	t.getContext = getContext

	var $js_img = $context.find(".js_img")
	var $js_feedback = $context.find(".js_feedback")
	var $js_answers_content = $context.find(".js_answers_content")
	var answers = []
	var has_feedback = data.feedback!=null

	initialize()

	function initialize() {
		trace ($context)
		$context.find(".js_statement").html(data.text)
		if (has_feedback) {
			$js_feedback.html(data.feedback)
		}
		if (data.image&&data.image!="") {
			$js_img.attr("src",data.image)
		} else {
			$js_img.remove()
		}
		createAnswers()
	}

	function createAnswers() {
		var arr = createAnswersArray(data.answers)

		var $li = $("<li></li>")
		for (var i = 0; i < arr.length; i++) {
			var itm = arr[i]
			var $itm = $(".tmps .js_components_tmps [data-type='"+itm.type+"']").clone()
			var ans = new omadapp.components[itm.type]($itm,itm,answerCallback)
			$js_answers_content.append ($itm)
			answers.push(ans)
		}

	}

	function answerCallback (answer) {
		trace ("answerCallback")
		trace (answer)
		$context.addClass("answered")
		if (has_feedback) {
			$js_feedback.removeClass("hidden")
		}
		$context.trigger("question-answered",answer)
	}

	function createAnswersArray(obj,sorted) {
		var arr = []
		for (var n in obj) {
			var itm = obj[n]
			itm.nid = n
			itm.rnd = Math.random()
			arr.push(itm)
		}
		if (!sorted) arr.sort((a, b) => a.rnd - b.rnd);

		return arr
	}

	function getContext() {
		return $context
	}
}